<script setup lang="ts">
import { computed } from 'vue'

import IconActionConfig from '@/components/atoms/icons/IconActionConfig.vue'
import BetaNavigationDisclosure from '@/components/beta-dashboard/molecules/BetaNavigationDisclosure.vue'
import type { BetaSettingsSection } from '@/types/beta-dashboard'
import {
    betaAdvancedSettingsLinks,
    type BetaAdvancedSettingsRouteName,
} from '@/utils/beta-settings-navigation'

const props = defineProps<{
    active?: boolean
    section: BetaSettingsSection
}>()

const emit = defineEmits<{
    select: [section: BetaSettingsSection]
    advanced: [routeName: BetaAdvancedSettingsRouteName]
}>()

const sectionItems: Array<{
    id: BetaSettingsSection
    label: string
    leading: string
}> = [
    { id: 'identity', label: 'Identidade', leading: 'Id' },
    { id: 'contact', label: 'Contato', leading: '@' },
    { id: 'integrations', label: 'Integrações', leading: '↔' },
    { id: 'domains', label: 'Domínios', leading: '.' },
]

const items = computed(() => [
    ...sectionItems.map((item) => ({
        id: `section:${item.id}`,
        label: item.label,
        leading: item.leading,
        current: props.active && props.section === item.id,
    })),
    ...betaAdvancedSettingsLinks.map((item, index) => ({
        id: `advanced:${item.routeName}`,
        label: item.navigationTitle,
        leading: item.leading,
        separator: index === 0,
        current: props.active && (
            (props.section === 'seo' && item.id === 'seo')
            || (props.section === 'advertising' && item.id === 'advertising')
            || (props.section === 'link-building' && item.id === 'link-building')
            || (props.section === 'redirects' && item.id === 'redirects')
            || (props.section === 'files' && item.id === 'files')
        ),
    })),
])

const selectItem = (id: string) => {
    if (id.startsWith('section:')) {
        emit('select', id.replace('section:', '') as BetaSettingsSection)
        return
    }

    if (!id.startsWith('advanced:')) return

    const routeName = id.replace('advanced:', '') as BetaAdvancedSettingsRouteName
    if (betaAdvancedSettingsLinks.some((item) => item.routeName === routeName)) {
        emit('advanced', routeName)
    }
}
</script>

<template>
    <BetaNavigationDisclosure
        label="Configurações"
        :icon="IconActionConfig"
        :items="items"
        :active="active"
        @select="selectItem"
    />
</template>
